import { render, staticRenderFns } from "./FirmManage.vue?vue&type=template&id=5477c24a&scoped=true"
import script from "./FirmManage.vue?vue&type=script&lang=js"
export * from "./FirmManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5477c24a",
  null
  
)

export default component.exports